export default {
  en: {
    '创建交易所 API 图文教程': 'Exchange API Setup Guide',
    '按步骤创建只读、交易权限的 API，再返回 UPlus 完成绑定': 'Follow the steps to create an API with read and trading permissions, then return to UPlus to bind it',
    '关闭教程': 'Close guide',
    '选择交易所教程': 'Select exchange guide',
    '查看中': 'Viewing',
    '查看教程': 'View guide',
    '当前教程': 'Current guide',
    '安全提醒': 'Security reminder',
    '只开启“只读”和“交易”权限，严禁开启提现权限。': 'Enable read and trading permissions only. Never enable withdrawal permission.',
    '开始创建并绑定 API': 'Create and bind an API',
    'UPlus 所需权限': 'Permissions required by UPlus',
    '✓ 只读': '✓ Read',
    '✓ 交易': '✓ Trade',
    '× 提现': '× Withdraw',
    '步骤': 'Step',
    '返回 UPlus 完成绑定': 'Return to UPlus to finish binding',
    '教程图片沿用 UPlus 原项目，交易所页面更新时请以交易所实际页面为准。': 'Guide images are from the original UPlus project. If an exchange page changes, follow the current exchange interface.',
    '我知道了，返回绑定': 'Got it, return to binding',
    '币安 API': 'Binance API',
    '欧易 API': 'OKX API',
    '进入 Binance API 管理页创建 API，完成安全验证后配置现货及合约交易权限。': 'Open Binance API Management, create an API, complete security verification, and configure spot and contract trading permissions.',
    '在绑定弹框中填写 API Key、Secret Key 和 6 位邮箱验证码，然后确认绑定。': 'Enter the API Key, Secret Key, and 6-digit email verification code in the binding dialog, then confirm.',
    '创建 API': 'Create API',
    '进入 API 管理并创建 API': 'Open API Management and create an API',
    '登录 Binance 后进入 API 管理，点击“创建 API”，并按页面要求完成安全验证。': 'After logging in to Binance, open API Management, click “Create API,” and complete the required security verification.',
    '配置权限': 'Configure permissions',
    '勾选 UPlus 所需交易权限': 'Select the trading permissions required by UPlus',
    '按图开启读取、现货交易和合约交易权限；不要开启提现权限。': 'Enable read, spot trading, and contract trading permissions as shown. Do not enable withdrawal permission.',
    '保存密钥': 'Save keys',
    '复制并妥善保存 API Key': 'Copy and securely save the API Key',
    'API Secret 通常只展示一次，请先保存后再回到 UPlus 填写。': 'The API Secret is usually shown only once. Save it before returning to UPlus.',
    '如果创建的是加密密钥或无法获得完整 Secret，请删除后重新创建普通 API。': 'If you created an encrypted key or cannot obtain the full Secret, delete it and create a standard API again.',
    '设置 IP': 'Set IP',
    '按提示设置 IP 白名单': 'Set the IP whitelist as instructed',
    '交易所提示需要绑定 IP 时，按下图进入访问限制并填写系统提供的 IP。': 'If the exchange requires an IP, open access restrictions as shown and enter the IP provided by the system.',
    '创建 API 时选择“绑定第三方 App”，应用程序选择 Uplus智能交易系统，并开启只读、交易权限。': 'When creating the API, select “Bind third-party app,” choose Uplus Smart Trading System, and enable read and trading permissions.',
    '在绑定弹框中填写 API Key、Secret Key、创建时设置的 Passphrase 和 6 位邮箱验证码。': 'Enter the API Key, Secret Key, Passphrase set during creation, and the 6-digit email code in the binding dialog.',
    '选择用途': 'Select purpose',
    '将 API 用途设置为 API 交易': 'Set API purpose to API Trading',
    '在 OKX 创建 API 的用途选项中选择“API 交易”。': 'Select “API Trading” as the API purpose in OKX.',
    '绑定应用': 'Bind app',
    '选择绑定第三方 App': 'Select Bind third-party app',
    '用途选择“绑定第三方 App”，然后在应用程序中查找 UPlus。': 'Select “Bind third-party app” and find UPlus in the application list.',
    '选择 UPlus': 'Select UPlus',
    '选择 Uplus智能交易系统': 'Select Uplus Smart Trading System',
    '在应用程序列表中选择“Uplus智能交易系统”。': 'Select “Uplus Smart Trading System” from the application list.',
    '只勾选只读和交易权限': 'Select read and trading permissions only',
    '权限选择“只读”和“交易”，不要开启提现权限。': 'Select “Read” and “Trade.” Do not enable withdrawal permission.',
    '先将 Gate.io 账户升级为统一账户，再创建用于 UPlus 查询与交易的 API。': 'Upgrade the Gate.io account to a Unified Account, then create an API for UPlus queries and trading.',
    '在绑定弹框中填写 Gate.io API Key、Secret Key 和 6 位邮箱验证码，然后确认绑定。': 'Enter the Gate.io API Key, Secret Key, and 6-digit email verification code in the binding dialog, then confirm.',
    '统一账户': 'Unified Account',
    '升级为统一账户': 'Upgrade to a Unified Account',
    '登录 Gate.io 后按图进入账户升级流程，先完成统一账户升级。': 'After logging in to Gate.io, follow the images to complete the Unified Account upgrade.',
    '创建 Gate.io API': 'Create a Gate.io API',
    '进入 API 管理创建密钥，并按图设置查询与交易权限。': 'Create a key in API Management and configure query and trading permissions as shown.',
    '不要开启提现权限；创建完成后立即保存 API Key 与 Secret Key。': 'Do not enable withdrawal permission. Save the API Key and Secret Key immediately after creation.',
    '从 Bybit 首页搜索 API，创建系统生成的 API Key，并配置查询与交易权限。': 'Search for API from the Bybit home page, create a system-generated API Key, and configure query and trading permissions.',
    '在绑定弹框中填写 Bybit API Key、API Secret 和 6 位邮箱验证码，然后确认绑定。': 'Enter the Bybit API Key, API Secret, and 6-digit email verification code in the binding dialog, then confirm.',
    '搜索 API': 'Search API',
    '在首页搜索 API': 'Search for API on the home page',
    '登录 Bybit，在首页搜索“API”，点击搜索结果进入 API 管理页。': 'Log in to Bybit, search for “API” on the home page, and open API Management from the result.',
    '创建密钥': 'Create key',
    '打开 API 创建页面': 'Open the API creation page',
    '点击“创建 API 密钥”，再点击“Create New Key”。': 'Click “Create API Key,” then “Create New Key.”',
    '密钥类型': 'Key type',
    '选择系统生成的 API 密钥': 'Select a system-generated API key',
    '选择“System-generated API keys”继续创建。': 'Select “System-generated API keys” to continue.',
    '配置 API 用途与权限': 'Configure API purpose and permissions',
    '按图开启读取与交易所需权限，严禁开启提现权限。': 'Enable the required read and trading permissions as shown. Never enable withdrawal permission.'
  },
  ko: {
    '创建交易所 API 图文教程': '거래소 API 설정 가이드',
    '按步骤创建只读、交易权限的 API，再返回 UPlus 完成绑定': '단계에 따라 읽기 및 거래 권한 API를 만든 뒤 UPlus로 돌아와 연결을 완료하세요',
    '关闭教程': '가이드 닫기',
    '选择交易所教程': '거래소 가이드 선택',
    '查看中': '보는 중',
    '查看教程': '가이드 보기',
    '当前教程': '현재 가이드',
    '安全提醒': '보안 안내',
    '只开启“只读”和“交易”权限，严禁开启提现权限。': '읽기 및 거래 권한만 활성화하고 출금 권한은 절대 활성화하지 마세요.',
    '开始创建并绑定 API': 'API 생성 및 연결 시작',
    'UPlus 所需权限': 'UPlus 필수 권한',
    '✓ 只读': '✓ 읽기',
    '✓ 交易': '✓ 거래',
    '× 提现': '× 출금',
    '步骤': '단계',
    '返回 UPlus 完成绑定': 'UPlus로 돌아가 연결 완료',
    '教程图片沿用 UPlus 原项目，交易所页面更新时请以交易所实际页面为准。': '가이드 이미지는 기존 UPlus 프로젝트를 사용합니다. 거래소 화면이 변경된 경우 현재 거래소 화면을 따르세요.',
    '我知道了，返回绑定': '확인, 연결로 돌아가기',
    '币安 API': 'Binance API',
    '欧易 API': 'OKX API',
    '进入 Binance API 管理页创建 API，完成安全验证后配置现货及合约交易权限。': 'Binance API 관리에서 API를 생성하고 보안 인증 후 현물 및 계약 거래 권한을 설정하세요.',
    '在绑定弹框中填写 API Key、Secret Key 和 6 位邮箱验证码，然后确认绑定。': '연결 창에 API Key, Secret Key와 6자리 이메일 인증 코드를 입력한 뒤 연결을 확인하세요.',
    '创建 API': 'API 생성',
    '进入 API 管理并创建 API': 'API 관리에서 API 생성',
    '登录 Binance 后进入 API 管理，点击“创建 API”，并按页面要求完成安全验证。': 'Binance 로그인 후 API 관리에서 “API 생성”을 클릭하고 안내에 따라 보안 인증을 완료하세요.',
    '配置权限': '권한 설정',
    '勾选 UPlus 所需交易权限': 'UPlus 필수 거래 권한 선택',
    '按图开启读取、现货交易和合约交易权限；不要开启提现权限。': '이미지와 같이 읽기, 현물 거래 및 계약 거래 권한을 켜고 출금 권한은 켜지 마세요.',
    '保存密钥': '키 저장',
    '复制并妥善保存 API Key': 'API Key 복사 및 안전하게 보관',
    'API Secret 通常只展示一次，请先保存后再回到 UPlus 填写。': 'API Secret은 보통 한 번만 표시됩니다. 저장한 뒤 UPlus로 돌아오세요.',
    '如果创建的是加密密钥或无法获得完整 Secret，请删除后重新创建普通 API。': '암호화 키를 만들었거나 전체 Secret을 확인할 수 없다면 삭제하고 일반 API를 다시 만드세요.',
    '设置 IP': 'IP 설정',
    '按提示设置 IP 白名单': '안내에 따라 IP 허용 목록 설정',
    '交易所提示需要绑定 IP 时，按下图进入访问限制并填写系统提供的 IP。': '거래소에서 IP 연결을 요구하면 이미지와 같이 접근 제한에 시스템 제공 IP를 입력하세요.',
    '创建 API 时选择“绑定第三方 App”，应用程序选择 Uplus智能交易系统，并开启只读、交易权限。': 'API 생성 시 “타사 앱 연결”을 선택하고 Uplus 스마트 거래 시스템에서 읽기 및 거래 권한을 켜세요.',
    '在绑定弹框中填写 API Key、Secret Key、创建时设置的 Passphrase 和 6 位邮箱验证码。': '연결 창에 API Key, Secret Key, 생성 시 설정한 Passphrase와 6자리 이메일 인증 코드를 입력하세요.',
    '选择用途': '용도 선택',
    '将 API 用途设置为 API 交易': 'API 용도를 API 거래로 설정',
    '在 OKX 创建 API 的用途选项中选择“API 交易”。': 'OKX API 용도에서 “API 거래”를 선택하세요.',
    '绑定应用': '앱 연결',
    '选择绑定第三方 App': '타사 앱 연결 선택',
    '用途选择“绑定第三方 App”，然后在应用程序中查找 UPlus。': '용도에서 “타사 앱 연결”을 선택하고 앱 목록에서 UPlus를 찾으세요.',
    '选择 UPlus': 'UPlus 선택',
    '选择 Uplus智能交易系统': 'Uplus 스마트 거래 시스템 선택',
    '在应用程序列表中选择“Uplus智能交易系统”。': '앱 목록에서 “Uplus 스마트 거래 시스템”을 선택하세요.',
    '只勾选只读和交易权限': '읽기 및 거래 권한만 선택',
    '权限选择“只读”和“交易”，不要开启提现权限。': '“읽기”와 “거래”만 선택하고 출금 권한은 켜지 마세요.',
    '先将 Gate.io 账户升级为统一账户，再创建用于 UPlus 查询与交易的 API。': 'Gate.io 계정을 통합 계정으로 업그레이드한 뒤 UPlus 조회 및 거래용 API를 만드세요.',
    '在绑定弹框中填写 Gate.io API Key、Secret Key 和 6 位邮箱验证码，然后确认绑定。': '연결 창에 Gate.io API Key, Secret Key와 6자리 이메일 인증 코드를 입력한 뒤 연결을 확인하세요.',
    '统一账户': '통합 계정',
    '升级为统一账户': '통합 계정으로 업그레이드',
    '登录 Gate.io 后按图进入账户升级流程，先完成统一账户升级。': 'Gate.io 로그인 후 이미지에 따라 계정 업그레이드를 진행하고 통합 계정 업그레이드를 완료하세요.',
    '创建 Gate.io API': 'Gate.io API 생성',
    '进入 API 管理创建密钥，并按图设置查询与交易权限。': 'API 관리에서 키를 만들고 이미지와 같이 조회 및 거래 권한을 설정하세요.',
    '不要开启提现权限；创建完成后立即保存 API Key 与 Secret Key。': '출금 권한은 켜지 말고 생성 즉시 API Key와 Secret Key를 저장하세요.',
    '从 Bybit 首页搜索 API，创建系统生成的 API Key，并配置查询与交易权限。': 'Bybit 홈에서 API를 검색하고 시스템 생성 API Key를 만든 뒤 조회 및 거래 권한을 설정하세요.',
    '在绑定弹框中填写 Bybit API Key、API Secret 和 6 位邮箱验证码，然后确认绑定。': '연결 창에 Bybit API Key, API Secret과 6자리 이메일 인증 코드를 입력한 뒤 연결을 확인하세요.',
    '搜索 API': 'API 검색',
    '在首页搜索 API': '홈에서 API 검색',
    '登录 Bybit，在首页搜索“API”，点击搜索结果进入 API 管理页。': 'Bybit 로그인 후 홈에서 “API”를 검색하고 결과를 눌러 API 관리로 이동하세요.',
    '创建密钥': '키 생성',
    '打开 API 创建页面': 'API 생성 페이지 열기',
    '点击“创建 API 密钥”，再点击“Create New Key”。': '“API 키 생성”을 클릭한 뒤 “Create New Key”를 클릭하세요.',
    '密钥类型': '키 유형',
    '选择系统生成的 API 密钥': '시스템 생성 API 키 선택',
    '选择“System-generated API keys”继续创建。': '“System-generated API keys”를 선택해 계속하세요.',
    '配置 API 用途与权限': 'API 용도 및 권한 설정',
    '按图开启读取与交易所需权限，严禁开启提现权限。': '이미지와 같이 읽기 및 거래 필수 권한만 켜고 출금 권한은 절대 켜지 마세요.'
  }
}
